module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/service_two-2b736cb4edf8b59c27df488eae9edc79.png";